document.addEventListener('alpine:init', function () {
    Alpine.data('productCard', function (productID) {
        return {
            favourite: false,
            expanded: false,
            init: function () {
                var _this = this;
                return function () {
                    _this.favourite = _this.$store.doors.has(productID);
                };
            },
            toggleFavourite: function () {
                this.$store.doors.toggle(productID);
                this.favourite = !this.favourite;
                // Trigger an event when toggling 'favourite'.
                this.$store.app.track({
                    event: 'product-card',
                    type: 'click',
                    trigger: 'favourite',
                    module: 'product-card',
                    data: {
                        product_id: productID,
                        favourite: this.favourite,
                    },
                });
            },
            toggleExpanded: function (force) {
                if (typeof force === 'boolean') {
                    this.expanded = force;
                }
                else {
                    this.expanded = !this.expanded;
                }
                // Trigger an event when the details are expanded.
                if (this.expanded) {
                    this.$store.app.track({
                        event: 'product-card',
                        type: 'click',
                        trigger: 'expand-details',
                        module: 'product-card',
                        data: {
                            product_id: productID,
                        },
                    });
                }
            },
        };
    });
});
